import * as Form from '../../../components/form'
import * as IsActive from '../../../components/is_active'

export const SEND_EMAIL_MODAL = 'SEND_EMAIL_MODAL'
export const UPDATE_EMAIL_ADDRESS = 'UPDATE_EMAIL_ADDRESS'
export const SEND_EMAIL_FUTURE_DATE = 'SEND_EMAIL_FUTURE_DATE'
export const FormConstants = Form.createConstantsMap(SEND_EMAIL_MODAL)
export const CHANGE_CUTOFF_DATE = 'CHANGE_CUTOFF_DATE'

export const SEND_SUCCESS = 'sendSuccess'
export const CONTENT_FAILURE = 'contentFailure'
export const OTHER_FAILURE = 'otherFailure'

export const SEND_SUCCESS_MESSAGE = 'Email has been sent. Please check your inbox'
export const CONTENT_FAILURE_MESSAGE =
  'Email not sent due to insufficient content. Please pick an earlier date below to look back for filler content. '
export const OTHER_FAILURE_MESSAGE = 'Unknown error. Please try again'

export const CUTOFF_SELECT_ONE_WEEK: IsActive.Filter = {
  description: 'One week ago',
  key: 'mode',
  value: '7',
}
export const CUTOFF_SELECT_TWO_WEEKS: IsActive.Filter = {
  description: 'Two weeks ago',
  key: 'mode',
  value: '14',
}
export const CUTOFF_SELECT_THREE_WEEKS: IsActive.Filter = {
  description: 'Three weeks ago',
  key: 'mode',
  value: '21',
}

export const selectedCutoffFilters: any = [CUTOFF_SELECT_ONE_WEEK, CUTOFF_SELECT_TWO_WEEKS, CUTOFF_SELECT_THREE_WEEKS]

export const PREVIEW_MODE_DESCRIPTION =
'This newsletter shows a preview of Lead Posts, Promotions and Lead Text entered \
for __DATE__. The other posts in this test email may not be reflective of \
what will be sent in your upcoming newsletter.'

export const DESIGN_MODE_DESCRIPTION =
'This newsletter shows all of the design elements for your template. \
The articles populated are for example purposes only and do not reflect \
what will be sent in your upcoming newsletter.'



// WEBPACK FOOTER //
// ./src/pages/content-calendar/send-email-modal/constants.ts